module.exports = __webpack_public_path__ + "static/media/community_1.b2649e6d.svg";